import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dqpjwo1i: FaireBrandEntity = {
  token: "b_dqpjwo1i",
  type: "brand",
  name: "VB&CO Designs Handmade Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/83374d7b3db5f5e566a921079e496226ea1af94bde2f13e40e8ff1fdb67e2ae4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/45ce1e89e4c5c51365a8c85b2c5fce0b02b78350887300ab093c9759f4b2d03e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/83374d7b3db5f5e566a921079e496226ea1af94bde2f13e40e8ff1fdb67e2ae4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/45ce1e89e4c5c51365a8c85b2c5fce0b02b78350887300ab093c9759f4b2d03e.jpeg",
  location: "Grayslake, IL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 323,
  isTopShop: true,
  isInsider: true,
  description:
    "Hello, I’m Nancy the artist behind VB&Co. Designs. I’m a self taught passionate jewelry artist that started my brand by making jewelry for close friends and family.  Soon after that, I started hosting home show jewelry parties and selling at craft shows. That’s where boutique owners started to approach me asking to offer wholesale pricing. Now I’m constantly creating new designs and always keeping a close eye on new jewelry trends. I have a large line and offer something for everyone. Classic, boho, vintage, trendy, rustic, bridal...you name it!!\nSome fun facts: VB&Co designs jewelry is handmade out of a small studio located in Grayslake, IL by a team of 16 Incredible crazy fun midwest ladies. We were recently featured on Good Morning America and WGN Chicago’s day time talk show. We LOVE what we do and we hope you do too!! \n**Please note: Our production time is constantly changing due to traveling for trade shows or getting slammed with orders so please feel free to message us on Faire or at [redacted-email] if you need your order by a certain date. We can usually meet your requested date and  bump your order up. \nWe look Forward to partnering up with you! \n-Nancy & The dream team💖",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:33.169Z",
    importedBy: "entity-db-cli",
  },
};
